module.exports = __webpack_public_path__ + "static/media/img1.f24e67b2.jpg";